export default {
  meta: {
    title: '点位测评-历史查询'
  }
};
